import { coreEngine, store } from "@dinahmoe/dmafjs-core";
import { VisualSuper } from "./visual-super.component.js";

class Svg extends VisualSuper {
  namespace = "visual:svg";
  handlers = this.extendParentHandlers({
    width: this.setWidth,
    height: this.setHeight,
  });

  init(node, event) {
    if (node.props["source.imageId"] === "") {
      super.init(node, event);
      return;
    }

    const imageData = store.get(`assets.data.${node.props["source.imageId"]}`);
    if (!imageData) {
      console.error(`Missing svg image ${node.props["source.imageId"]}`);
      return;
    }

    super.init(node, event);
  }

  setWidth(node) {
    super.setWidth(node);

    if (node.shouldUpdateHeight) {
      node.height = node.props["size.width"] / node.ratio;
    }
  }

  setHeight(node) {
    super.setHeight(node);

    if (node.shouldUpdateWidth) {
      node.width = node.props["size.height"] * node.ratio;
    }
  }
}

const svg = new Svg();
export { Svg, svg };
